import React, { Fragment } from "react";

import { ThemeProvider } from 'styled-components'
import { ContentfulClient, ContentfulProvider, Query } from 'react-contentful';

import { theme, GlobalStyle } from './components/typography';
import SiteHeader from './components/siteheader';
import Background from './components/background';
import TopImage from './components/topimage';
import Content from './components/content';
import ContactForm from './components/contactform';
import Footer from './components/footer';

const contentfulClient = new ContentfulClient({
  accessToken: 'hqCOv22oRyEBapW0JarDLNpxkpVFDShMQfxj6T0k0_s',
  space: 'u3b2zkym737q'
});

function App(){

  let contentType = 'WebsiteConfig';
  let configId = '129F4YUH4FpxuZRwsv3ypn';


  return (
    <ThemeProvider theme={theme}>
      <ContentfulProvider client={contentfulClient} locale="nl">
        <GlobalStyle />
        <Query contentType={contentType} id={configId}>
            {({data, error, fetched, loading}) => {
              if (loading || !fetched) {
                return null;
              }

              if (error) {
                console.error(error);
                return null;
              }

              if (!data) {
                return <p>Page does not exist.</p>;
              }

              return (
                <Fragment>
                  <Background content={data.fields}></Background>
                  <SiteHeader content={data.fields}></SiteHeader>
                  <TopImage content={data.fields}></TopImage>
                  <Content content={data.fields}></Content>
                  <ContactForm />
                  <Footer></Footer>
                </Fragment>
              )
            }
          }
        </Query>
      </ContentfulProvider>
    </ThemeProvider>
  );
}

export default App;
